import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { EcReceiptItem_ManagementECPage_Query } from "./query";

type Props = {
	queryVariables?: {
		hotelID: string;
		receiptID: string;
	};
};

export const useSuspenseFetchEcReceiptByReceiptID = ({ queryVariables }: Props) => {
	const { data } = useCustomSuspenseQuery(
		EcReceiptItem_ManagementECPage_Query,
		queryVariables ? { variables: queryVariables } : undefined,
		queryVariables === undefined, // skipToken = true
	);
	return {
		queryData: data?.ecReceiptItem ? [data.ecReceiptItem] : [],
	};
};
